import { useNavigate } from "react-router-dom";
const UnAuthorized = () => {

    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <section>
            <h1>Unauthorized Access</h1>
            <br />
            <p>You do not have access to the reuested page. </p>
            <div className="flexGrow">
                <button onClick={goBack}>Go Back</button>
            </div>
        </section>

    )
}

export default UnAuthorized